<template>
    <dx-button
        :class="stylingMode + ` ai-button-disabled text-[12px] font-[600] rounded-[8px] min-w-[180px] h-[40px]`"
        :text="text"
        :disabled="disabled"
        @click="click"
    />
</template>

<script setup>
import { DxButton } from 'devextreme-vue';

const emit = defineEmits(['click']);

defineProps({
    text: {
        type: String,
        default: '',
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    stylingMode: {
        type: String,
        default: 'blue',
    },
});

const click = () => {
    emit('click');
};
</script>

<style lang="scss">
.blue,
.blue:focus {
    color: #ffffff;
    background: #286eb6;

    :hover {
        background: #1c5ea2;
    }

    :active {
        background: #0d457f;
    }
}

.light-blue,
.light-blue:focus {
    color: #031425;
    background: #cbe1f7;

    :hover {
        background: #aacced;
    }

    :active {
        background: #a6c7e9;
    }
}

.ai-button-disabled {
    .dx-button.dx-state-disabled.dx-button-mode-contained {
        background: #286eb6b2;
    }

    .dx-button.dx-state-disabled .dx-button-text {
        color: #ffffff;
    }
}
</style>
